import { ingredientDisplayName, isLanguage, PerfumeIngredient } from "@/models";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export { capitalizeIngredientName, defaultLanguage } from "@/models";

export function useIngredientDiplayName(unknown?: string) {
  const { i18n } = useTranslation();
  const activeLocale = i18n.resolvedLanguage;

  if (!isLanguage(activeLocale)) {
    throw Error(`Unsupported language for ingredient l18n: ${activeLocale}`);
  }

  return useCallback(
    (ingredient: PerfumeIngredient | null) =>
      ingredient === null
        ? (unknown ?? "(Unknown ingredient)")
        : ingredientDisplayName(ingredient, activeLocale),

    [activeLocale, unknown],
  );
}
